import AccountRestricted from './AccountRestricted.jsx';

export default AccountRestricted;